<template>
  <accordion :title="billTitle">
    <template #accordion-badge>
      <bill-tag :bill="bill" />
    </template>

    <template v-if="isBillExempted">
      Mensalidade isenta
    </template>

    <template v-else-if="isIgnored">
      <div class="z-text spacer-bottom-s spacer-bottom-s">
        Mensalidade ignorada

        <template v-if="bill.ignored_reason">
          com base em <strong>{{ bill.ignored_reason.label }}</strong>
        </template>
      </div>

      <div class="z-text spacer-bottom-s">
        <strong>Valor da mensalidade:</strong> {{ bill.full_value | formatCurrency }}
      </div>
    </template>

    <template v-else-if="bill.status === 'open'">
      <div class="z-text spacer-bottom-s">
        <strong>Valor da mensalidade:</strong> {{ bill.full_value | formatCurrency }}
      </div>

      <div class="z-text spacer-bottom-l">
        <strong>Data de vencimento:</strong> {{ formatDueDate(bill.due_date) }}
      </div>

      <router-link
        tag="button"
        :to="{ name: 'nb-payment-methods', params: { billId: bill.id } }"
        class="z-button z-button--primary z-button--block"
      >
        Adiantar pagamento
      </router-link>
    </template>

    <overdue-bill-info :bill="bill" v-else-if="bill.status === 'pending'" />

    <template v-else>
      <div class="z-text spacer-bottom-s">
        <strong>Valor da mensalidade:</strong> {{ bill.full_value | formatCurrency }}
      </div>

      <div class="z-text spacer-bottom-s" v-if="bill.penalty > 0">
        <strong>Valor da multa:</strong> {{ bill.penalty | formatCurrency }}
      </div>

      <div class="z-text spacer-bottom-s" v-if="bill.interest > 0">
        <strong>Valor do juros:</strong> {{ bill.interest | formatCurrency }}
      </div>

      <div class="z-text spacer-bottom-s">
        <strong>Data do pagamento:</strong> {{ bill.paid_date | formatDate }}
      </div>

      <div class="z-text spacer-bottom-l">
        <strong>Forma do pagamento:</strong> {{ bill.translated_payment_method }}
      </div>

      <router-link
        tag="button"
        :to="{ name: 'payment-receipt', params: { billId: bill.id }, query: { from: 'payments-history' } }"
        class="z-button z-button--primary z-button--block"
      >
        Ver comprovante de pagamento
      </router-link>
    </template>
  </accordion>
</template>

<script>
import Accordion from 'components/accordion';
import DateUtils from 'utils/date-utils';
import BillTag from './bill-tag';
import OverdueBillInfo from './overdue-bill-info';

export default {
  components: {
    Accordion,
    BillTag,
    OverdueBillInfo,
  },
  props: {
    bill: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBillExempted() {
      return this.bill.status === 'paid' && this.bill.bill_value === '0.0';
    },
    isIgnored() {
      return this.bill.status === 'ignored';
    },
    reenrollmentBill() {
      return this.bill.metadata && this.bill.metadata.reenrollment_id;
    },
    billTitle() {
      if (this.reenrollmentBill) return `${this.bill.month_name} (Rematrícula)`;

      return this.bill.month_name;
    },
  },
  methods: {
    formatDueDate(date) {
      return DateUtils.getFormattedDate(date);
    },
  },
};
</script>
